import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
} from '@material-ui/core';
import { Add as AddIcon, Edit as EditIcon } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { PageFilter } from '../../../state/app';
import { AppState } from '../../../state/configureStore';
import {
  clearSampleDevelopmentNl,
  fetchSampleDevelopmentNlList,
  SampleDevelopmentNlState,
  SampleDevelopmentNlListFilter,
} from '../../../state/sampleDevelopmentNl';
import {
  PageContainer,
  PageTitle,
  TableLoading,
  PageButtonGroup,
  DateTimeDisplay,
  SortLabel,
} from '../../components';
import { useFilter, useTableSorting } from '../../hooks';
import { SampleDevelopmentStatusLabel } from '../../../constants/sampleDevelopmentStatus';
import SampleDevelopmentNlFilter from './SampleDevelopmentNlFilter';

const initialSampleDevelopmentNlListFilter: SampleDevelopmentNlListFilter = {
  'Status.equalsTo': '',
};

const SampleDevelopmentNlList: React.FC<RouteComponentProps> = (props) => {
  const dispatch = useDispatch();
  const { history } = props;
  const [filters, setFilters] = useFilter<SampleDevelopmentNlListFilter>(
    initialSampleDevelopmentNlListFilter,
  );

  const [sort, setSort] = useTableSorting({
    orderBy: 'sampleDevNumber',
    direction: 'desc',
  });

  const [paging, setPaging] = useState<PageFilter>({
    pageNumber: 0,
    pageSize: 15,
  });

  const { items: sampleDevelopmentNlList, totalItems, loading } = useSelector<
    AppState,
    SampleDevelopmentNlState
  >((state) => state.sampleDevelopmentNl);

  const handleChangeFilter = (newFilter: SampleDevelopmentNlListFilter): void => {
    setFilters(newFilter);
    setPaging({
      ...paging,
      pageNumber: 0,
    });
  };

  const handleChangePageNumber = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    newPage: number,
  ) => {
    setPaging({ ...paging, pageNumber: newPage });
  };

  const handleChangePageSize = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setPaging({
      ...paging,
      pageSize: +event.target.value,
      pageNumber: 0,
    });
  };

  useEffect(() => {
    dispatch(fetchSampleDevelopmentNlList(filters, { ...paging, sort }));
    return function cleanUp() {
      dispatch(clearSampleDevelopmentNl());
    };
  }, [dispatch, paging, filters, sort]);

  const addNewSampleDevelopmentNl = (): void => {
    history.push('/sampleDevelopmentNl/form');
  };

  const editSampleDevelopmentNl = (id: number): void => {
    history.push(`/sampleDevelopmentNl/form/${id}`);
  };

  return (
    <PageContainer>
      <PageTitle>Sample Development NL</PageTitle>
      <SampleDevelopmentNlFilter
        filters={filters}
        onChangeFilter={handleChangeFilter}
        initialFilter={initialSampleDevelopmentNlListFilter}
      />
      <PageButtonGroup>
        <Button
          variant="contained"
          color="primary"
          onClick={addNewSampleDevelopmentNl}
          startIcon={<AddIcon />}
        >
          New Sample Development NL
        </Button>
      </PageButtonGroup>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>No.</TableCell>
            <TableCell>
              <SortLabel sort={sort} handleSortChange={setSort} field="sampleDevNumber">
                Running Number
              </SortLabel>
            </TableCell>
            {/* <TableCell>Status</TableCell> */}
            <TableCell>Program</TableCell>
            {/* <TableCell>Brand</TableCell> */}
            <TableCell>Item</TableCell>
            <TableCell>Block</TableCell>
            <TableCell>Created At</TableCell>
            <TableCell>Created By</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableLoading isLoading={loading} colSpan={10}>
            {sampleDevelopmentNlList.map((sampleDevelopmentNl, index) => (
              <TableRow key={sampleDevelopmentNl.id}>
                <TableCell>{index + paging.pageSize * paging.pageNumber + 1}</TableCell>
                <TableCell>{sampleDevelopmentNl.sampleDevNumber}</TableCell>
                {/* <TableCell>
                  {SampleDevelopmentStatusLabel[sampleDevelopmentNl.status!]}
                </TableCell> */}
                <TableCell>{sampleDevelopmentNl.block!.program!.name}</TableCell>
                {/* <TableCell>{sampleDevelopmentNl.block!.brand!.name}</TableCell> */}
                <TableCell>{sampleDevelopmentNl.block!.item}</TableCell>
                <TableCell>{sampleDevelopmentNl.block!.blockNo}</TableCell>
                <TableCell>
                  <DateTimeDisplay value={sampleDevelopmentNl.createdAt} />
                </TableCell>
                <TableCell>{sampleDevelopmentNl.createdBy}</TableCell>
                <TableCell>
                  <Tooltip title={'Edit'}>
                    <span>
                      <IconButton
                        size="small"
                        onClick={() => editSampleDevelopmentNl(sampleDevelopmentNl.id!)}
                      >
                        <EditIcon />
                      </IconButton>
                    </span>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableLoading>
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[15, 25, 35]}
        component="div"
        count={totalItems}
        rowsPerPage={paging.pageSize}
        page={paging.pageNumber}
        onPageChange={handleChangePageNumber}
        onRowsPerPageChange={handleChangePageSize}
      />
    </PageContainer>
  );
};

export default SampleDevelopmentNlList;
